/* eslint-disable max-lines */
import {
  removeAccessToken,
  removeUnauthorizedToken,
  removeUserId,
  removeUserStatus,
  setAccessToken,
  setUserId,
  setUserStatus,
} from '../../../utils/auth';
import { hidePopup } from '../popup';
import userApi from './api';
import * as types from './actionTypes';

import { resetAddressState } from '../address/actions';
import { fetchCards, resetCardState } from '../card/actions';
import { resetPayuCardState } from '../payuCard/actions';
import { resetCartState } from '../cart/actions';
import { resetOrderState } from '../order/actions';
import { clearStockDone } from '../stock/actions';

export const login = () => ({
  type: types.LOGIN_SUCCESS,
});

function signUpStart() {
  return { type: types.SIGNUP_REQUEST };
}

function signUpDone(data) {
  return {
    type: types.SIGNUP_SUCCESS,
    payload: data,
  };
}

function signUpFail(error) {
  return {
    type: types.SIGNUP_FAILURE,
    error,
  };
}

export const signUp = (values, onSuccessCallback) => {
  return dispatch => {
    dispatch(signUpStart());

    return userApi
      .signUp(values)
      .then(data => {
        removeUnauthorizedToken();
        setAccessToken(data.access_token);
        dispatch(login());

        if (onSuccessCallback) {
          onSuccessCallback();
        }

        return dispatch(signUpDone(data));
      })
      .catch(({ message }) => {
        return dispatch(signUpFail(message));
      });
  };
};

export const resetSignUp = () => ({
  type: types.RESET_SIGNUP,
});

export const signIn = (values, onSuccessCallback, onFailureCallback) => {
  return dispatch => {
    dispatch({ type: types.SIGNIN_REQUEST });

    return userApi
      .signIn(values)
      .then(data => {
        const userStatus = ((data || {}).loyalty || {}).status;
        const { statuses } = (data || {}).loyalty || {};
        const { id, access_token } = data || {};
        const statusLabel = ((statuses || []).find(x => x.code === userStatus) || {}).name;

        removeUnauthorizedToken();
        setAccessToken(access_token);
        setUserId(id);
        setUserStatus(statusLabel);
        dispatch(login());
        dispatch(hidePopup('auth', { step: '' }));

        onSuccessCallback?.();

        return dispatch({ type: types.SIGNIN_SUCCESS, payload: data });
      })
      .catch(({ message }) => {
        onFailureCallback?.(message);

        return dispatch({ type: types.SIGNIN_FAILURE });
      });
  };
};

// Разлогиниться
const signOutStart = () => ({ type: types.SIGNOUT_REQUEST });
const signOutDone = () => ({ type: types.SIGNOUT_SUCCESS });
const signOutFail = payload => ({ type: types.SIGNOUT_FAILURE, payload });

/**
 * Разлогинимся
 */
export const signOut = () => {
  return dispatch => {
    dispatch(signOutStart());

    return userApi
      .signOut()
      .then(() => {
        // сбрасываем адреса в стейте
        dispatch(resetAddressState());
        // сбрасываем карты в стейте
        dispatch(resetCardState());
        dispatch(resetPayuCardState());
        // сбрасываем заказ
        dispatch(resetOrderState());
        // сбрасываем введеный промокод
        dispatch(clearStockDone());
        // сбрасываем корзину
        dispatch(resetCartState());

        removeAccessToken();
        removeUserId();
        removeUserStatus();

        return dispatch(signOutDone());
      })
      .catch(({ message }) => dispatch(signOutFail(message)));
  };
};

export const deleteAccount = () => {
  return dispatch => {
    return userApi
      .delAccount()
      // .then(() => (dispatch(signOut())))
      .catch(({ message }) => {
        return dispatch(updateProfileFail(message));
      });
  };
};

function recoveryPhoneConfirmSmsStart() {
  return { type: types.RECOVERY_PHONE_CONFIRM_SMS_REQUEST };
}

function recoveryPhoneConfirmSmsDone() {
  return {
    type: types.RECOVERY_PHONE_CONFIRM_SMS_SUCCESS,
  };
}

function recoveryPhoneConfirmSmsFail(error) {
  return {
    type: types.RECOVERY_PHONE_CONFIRM_SMS_FAILURE,
    error,
  };
}

export const recoveryPhoneConfirmSms = values => {
  return dispatch => {
    dispatch(recoveryPhoneConfirmSmsStart());
    return userApi
      .sendConfirmCode(values)
      .then(({ status }) => (status ? dispatch(recoveryPhoneConfirmSmsDone()) : false))
      .catch(({ message }) => dispatch(recoveryPhoneConfirmSmsFail(message)));
  };
};

function recoveryPasswordSendConfirmCodeStart() {
  return { type: types.RECOVERY_PASSWORD_SEND_CONFIRM_CODE_REQUEST };
}

function recoveryPasswordSendConfirmCodeDone() {
  return {
    type: types.RECOVERY_PASSWORD_SEND_CONFIRM_CODE_SUCCESS,
  };
}

function recoveryPasswordSendConfirmCodeFail(error) {
  return {
    type: types.RECOVERY_PASSWORD_SEND_CONFIRM_CODE_FAILURE,
    error,
  };
}

export function recoveryPasswordSendConfirmCodeReset() {
  return {
    type: types.RECOVERY_PASSWORD_SEND_CONFIRM_CODE_RESET,
  };
}

export const recoveryPasswordSendConfirmCode = values => {
  return dispatch => {
    dispatch(recoveryPasswordSendConfirmCodeStart());
    return userApi
      .sendConfirmCode(values)
      .then(() => {
        return dispatch(recoveryPasswordSendConfirmCodeDone());
      })
      .catch(({ message }) => dispatch(recoveryPasswordSendConfirmCodeFail(message)));
  };
};

function recoveryPasswordStart() {
  return { type: types.RECOVERY_PASSWORD_REQUEST };
}

function recoveryPasswordDone() {
  return {
    type: types.RECOVERY_PASSWORD_SUCCESS,
  };
}

function recoveryPasswordFail(error) {
  return {
    type: types.RECOVERY_PASSWORD_FAILURE,
    error,
  };
}

export function recoveryPasswordReset() {
  return {
    type: types.RECOVERY_PASSWORD_RESET,
  };
}

export const recoveryPassword = values => {
  return dispatch => {
    dispatch(recoveryPasswordStart());
    return userApi
      .recoveryPassword(values)
      .then(() => {
        return dispatch(recoveryPasswordDone());
      })
      .catch(({ message }) => dispatch(recoveryPasswordFail(message)));
  };
};

export const rememberPhone = phone => {
  return {
    type: types.RECOVERY_PASSWORD_REMEMBER_PHONE,
    payload: phone,
  };
};

export const rememberEmail = email => {
  return {
    type: types.RECOVERY_PASSWORD_REMEMBER_EMAIL,
    payload: email,
  };
};

export const fetchProfile = params => {
  return (dispatch, getState) => {
    const isAllowedCity = !getState().city.waitOpenings;

    if (!isAllowedCity) {
      return null;
    }

    dispatch({ type: types.FETCH_PROFILE_REQUEST });
    return userApi
      .getProfile(params)
      .then(data => {
        return dispatch({ type: types.FETCH_PROFILE_SUCCESS, payload: data });
      })
      .catch(() => {
        return dispatch({ type: types.FETCH_PROFILE_FAILURE });
      });
  };
};

function updateProfileStart() {
  return { type: types.UPDATE_PROFILE_REQUEST };
}

function updateProfileDone(data) {
  return {
    type: types.UPDATE_PROFILE_SUCCESS,
    data,
  };
}

function updateProfileFail(error) {
  return {
    type: types.UPDATE_PROFILE_FAILURE,
    error,
  };
}

export const updateProfileReset = () => {
  return {
    type: types.UPDATE_PROFILE_RESET,
  };
};

export const updateProfile = payload => {
  return dispatch => {
    dispatch(updateProfileStart());

    return userApi
      .updateProfile(payload)
      .then(data => {
        dispatch(updateProfileDone(data));
      })
      .then(() => {
        dispatch(fetchCards());
      })
      .catch(({ message }) => dispatch(updateProfileFail(message)));
  };
};

export const setAvatar = params => {
  return dispatch => {
    dispatch(updateProfileStart());

    return userApi
      .setAvatar(params)
      .then(data => {
        return dispatch(updateProfileDone(data));
      })
      .catch(({ message }) => {
        return dispatch(updateProfileFail(message));
      });
  };
};

export const setBonuses = number => {
  return {
    type: types.SET_BONUSES,
    payload: number,
  };
};

export const clearUserErrors = keys => {
  return {
    type: types.CLEAR_USER_ERRORS,
    payload: keys,
  };
};
